import { ListRouterQuery } from '@/interfaces/filters'

export const MAX_NUMBER_OF_RELATED_PROJECTS = 5

export const RELATED_PROJECTS_PARAMS: ListRouterQuery = {
  limit: '10', // api limitation, cannot be less than 10
  sortBy: 'project_copies'
}
